export const removeKey = (key, obj) =>
  Object.entries(obj).reduce((a, [k, v]) => (k === key ? a : { ...a, [k]: v }), {});

export const compositeKey = (keys, obj, sep = '-') => keys.map((x) => obj[x]).join('-');

export const removeEmpty = (obj) =>
  Object.entries(obj).reduce(
    (a, [k, v]) => ([undefined, ''].includes(v) ? a : { ...a, [k]: v }),
    {},
  );
